
export function jumpProgram (data) {
    //跳转小程序方案详情
    //判断环境
    let u = navigator.userAgent
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        window.jxyy.gotoMiniProgram(data.originalId, data.miniPath)
    } else if (isiOS) {
        let obj = {
            originalId: data.originalId,
            miniPath: data.miniPath
        }
        window.webkit.messageHandlers.gotoMiniProgram.postMessage(obj);
    }
}